import type { ColoredMaterial } from "@color-finder/color-finder-api/models";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { TextDisplay } from "components/dataDisplay/TextDisplay";
import type { FC } from "react";
import ColorStatusDisplay from "../dataDisplay/ColorStatusDisplay";
import { GlobalSubstanceListOverview } from "./GlobalSubstanceListOverview";

export interface AvailabilityInformationProps {
  material: ColoredMaterial;
  isInternal?: boolean;
}

export const AvailabilityInformation: FC<AvailabilityInformationProps> = ({
  material,
  isInternal,
}) => {
  return (
    <Grid container spacing={1}>
      {isInternal && (
        <>
          <Grid size={{ xs: 5 }}>
            <Typography variant="label">CDC / Color Lab</Typography>
          </Grid>
          <Grid size={{ xs: 7 }}>
            <TextDisplay value={material.availability.cdc} />
          </Grid>
        </>
      )}
      <Grid size={{ xs: 5 }}>
        <Typography variant="label">
          SAP article number
          <br />
          (UVP color / YU)
        </Typography>
      </Grid>
      <Grid size={{ xs: 7 }}>
        <TextDisplay value={material.availability.productNumber} />
      </Grid>
      {isInternal && (
        <>
          <Grid display="flex" alignItems="center" size={{ xs: 5 }}>
            <Typography variant="label">Color Status</Typography>
          </Grid>
          <Grid size={{ xs: 7 }}>
            <ColorStatusDisplay value={material.availability.colorStatus} />
          </Grid>
          <Grid size={{ xs: 7 }}>
            <Typography variant="label">Chemical Substance Listing</Typography>
          </Grid>
          <Grid size={{ xs: 7 }}>
            <GlobalSubstanceListOverview
              value={material.availability.globalSubstanceList ?? []}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};
